import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const emailtypology = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/organization/{profile}/email-typology',
    app: 'organization'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'organization', model: 'emailtypology' }
    ),
    { }
  )
)()

export { emailtypology, TYPES }
